(()=>{
  const ALLOWED=new Set([1,4,5,8,10,14,16,17,19]);
  const step1=document.querySelector('.guided-step[data-step="1"]');
  const step2=document.querySelector('.guided-step[data-step="2"]');
  const picker=document.getElementById('vehicle-exact-picker');
  const pickup=document.getElementById('pickup-date');
  const ret=document.getElementById('return-date');
  if(!step1||!picker)return;

  if(!document.getElementById('area-b-filter-styles')){
    const style=document.createElement('style');
    style.id='area-b-filter-styles';
    style.textContent=`
      .area-b-box{display:flex;align-items:flex-start;gap:12px;margin:12px 0 2px;padding:14px 15px;border:1px solid #d9ddde;border-radius:15px;background:#f7f8f8;cursor:pointer}
      .area-b-box input{width:21px;height:21px;min-width:21px;margin:1px 0 0;accent-color:#111;cursor:pointer}
      .area-b-copy strong{display:block;font-size:14px;line-height:1.25;color:#111}
      .area-b-copy small{display:block;margin-top:4px;font-size:11px;line-height:1.4;color:#687174}
      .area-b-box.is-active{border-color:#111;background:#eef7f1}
      .area-b-box.is-weekend{background:#f1f3f3;border-color:#d9ddde;cursor:default}
      .area-b-box.is-weekend input{opacity:.45;cursor:not-allowed}
      .area-b-active .vehicle-option.area-b-incompatible{display:none!important}
      .area-b-note{display:none;margin:0 0 10px;padding:10px 12px;border-radius:12px;background:#eef7f1;color:#166a37;font-size:11px;font-weight:800;line-height:1.35}
      .area-b-note.show{display:block}
    `;
    document.head.appendChild(style);
  }

  const DEFAULT_HELP='Attiva il flag se devi entrare in Area B o in una zona urbana con restrizioni ambientali. Ti mostreremo solo i mezzi compatibili.';
  const WEEKEND_HELP='Sabato e domenica il filtro Area B non serve: puoi scegliere tra tutti i mezzi disponibili.';
  const box=document.createElement('label');
  box.className='area-b-box';
  box.innerHTML=`<input id="area-b-access" type="checkbox"><span class="area-b-copy"><strong>Devi accedere in Area B?</strong><small>${DEFAULT_HELP}</small></span>`;
  step1.appendChild(box);
  const checkbox=box.querySelector('#area-b-access');
  const copySmall=box.querySelector('.area-b-copy small');

  const note=document.createElement('div');
  note.className='area-b-note';
  note.textContent='Filtro Area B attivo: vengono mostrati solo i mezzi compatibili.';
  step2?.insertBefore(note,step2.children[1]||null);

  const parseDate=value=>{
    if(!value)return null;
    const [y,m,d]=String(value).split('-').map(Number);
    if(!y||!m||!d)return null;
    const ts=Date.UTC(y,m-1,d);
    return Number.isFinite(ts)?ts:null;
  };
  const isWeekendOnly=()=>{
    const start=parseDate(pickup?.value);
    const end=parseDate(ret?.value);
    if(start===null||end===null||end<start)return false;
    for(let ts=start;ts<=end;ts+=86400000){
      const day=new Date(ts).getUTCDay();
      if(day!==0&&day!==6)return false;
    }
    return true;
  };
  const numberFromOption=option=>{
    const alt=option?.querySelector('img')?.alt||'';
    const m=alt.match(/N\.?\s*(\d+)/i);
    return m?Number(m[1]):null;
  };
  const selectedNumber=()=>{
    const m=(picker.querySelector('.vehicle-picker-title')?.textContent||'').match(/N\.?\s*(\d+)/i);
    return m?Number(m[1]):null;
  };
  const clearSelection=()=>{
    const title=picker.querySelector('.vehicle-picker-title');
    const preview=picker.querySelector('.vehicle-preview');
    const autoRate=picker.querySelector('.vehicle-auto-rate');
    if(title)title.textContent='Seleziona un furgone';
    preview?.classList.remove('show');
    if(autoRate)autoRate.classList.add('empty');
    const autoRateValue=autoRate?.querySelector('b');
    if(autoRateValue)autoRateValue.textContent='Seleziona un furgone';
    const total=document.getElementById('km-total');
    if(total)total.textContent='—';
    const wa=document.getElementById('km-wa-btn');
    if(wa){wa.classList.remove('show');wa.href='#';}
    const status=document.getElementById('km-status');
    if(status)status.textContent='Filtro Area B attivo: scegli uno dei mezzi compatibili mostrati.';
  };
  const rewriteWhatsApp=active=>{
    const wa=document.getElementById('km-wa-btn');
    if(!wa||!wa.href||wa.href==='#')return;
    try{
      const u=new URL(wa.href);
      let text=u.searchParams.get('text')||'';
      text=text.replace(/\nArea B \/ zona con restrizioni ambientali: (SÌ|NO)/g,'');
      if(active)text+='\nArea B / zona con restrizioni ambientali: SÌ';
      u.searchParams.set('text',text);
      wa.href=u.toString();
    }catch(e){}
  };
  const apply=()=>{
    const weekend=isWeekendOnly();
    if(weekend){
      checkbox.checked=false;
      checkbox.disabled=true;
    }else{
      checkbox.disabled=false;
    }
    const active=!weekend&&checkbox.checked;
    document.body.classList.toggle('area-b-active',active);
    box.classList.toggle('is-active',active);
    box.classList.toggle('is-weekend',weekend);
    note.classList.toggle('show',active);
    if(copySmall)copySmall.textContent=weekend?WEEKEND_HELP:DEFAULT_HELP;

    picker.querySelectorAll('.vehicle-option').forEach(option=>{
      const n=numberFromOption(option);
      option.classList.toggle('area-b-incompatible',Boolean(n&&!ALLOWED.has(n)));
      option.classList.toggle('area-b-compatible',Boolean(n&&ALLOWED.has(n)));
    });

    const selected=selectedNumber();
    if(active&&selected&&!ALLOWED.has(selected))clearSelection();
    rewriteWhatsApp(active);
    if(typeof window.gtag==='function')window.gtag('event','area_b_filter_change',{
      attivo:active,
      weekend_senza_filtro:weekend,
      mezzi_compatibili:active?ALLOWED.size:18
    });
  };

  checkbox.addEventListener('change',apply);
  pickup?.addEventListener('change',()=>setTimeout(apply,0));
  ret?.addEventListener('change',()=>setTimeout(apply,0));
  document.getElementById('km-calc-btn')?.addEventListener('click',()=>setTimeout(apply,80));
  picker.addEventListener('click',()=>setTimeout(()=>{if(checkbox.checked){const n=selectedNumber();if(n&&!ALLOWED.has(n))clearSelection();}},0));
  new MutationObserver(()=>{if(checkbox.checked)apply();}).observe(picker,{childList:true,subtree:true});
  apply();
})();